import { navLinks } from "../data/mock";
import { Linkedin, Twitter, Mail } from "lucide-react";
import { Logo } from "./Logo";

export const Footer = () => {
  const handleNavClick = (e, href) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <footer className="bg-white border-t border-slate-100">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16">
        <div className="grid md:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="md:col-span-2">
            <a href="/">
              <Logo />
            </a>
            <p className="mt-4 text-sm text-slate-400 leading-relaxed max-w-sm font-body">
              AI-powered tender management for Indian businesses. Find, analyze,
              and win government contracts faster.
            </p>
            <p className="mt-4 text-sm font-semibold text-indigo-500">
              {">>"}  fast-forward your tenders
            </p>
          </div>

          {/* Product Links */}
          <div>
            <h4 className="text-sm font-bold text-slate-900 mb-4">Product</h4>
            <ul className="space-y-3">
              {navLinks.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    onClick={(e) => handleNavClick(e, link.href)}
                    className="text-sm text-slate-400 hover:text-slate-700 transition-colors duration-200"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
              <li>
                <a
                  href="#"
                  className="text-sm text-slate-400 hover:text-slate-700 transition-colors duration-200"
                >
                  Privacy Policy
                </a>
              </li>
              <li>
                <a
                  href="#"
                  className="text-sm text-slate-400 hover:text-slate-700 transition-colors duration-200"
                >
                  Terms of Service
                </a>
              </li>
            </ul>
          </div>

          {/* Connect */}
          <div>
            <h4 className="text-sm font-bold text-slate-900 mb-4">Connect</h4>
            <div className="flex items-center gap-4">
              <a
                href="#"
                className="w-9 h-9 rounded-lg bg-slate-50 border border-slate-100 flex items-center justify-center text-slate-400 hover:text-indigo-600 hover:bg-indigo-50 hover:border-indigo-100 hover:scale-110 transition-all duration-200"
                aria-label="Twitter"
              >
                <Twitter size={16} />
              </a>
              <a
                href="#"
                className="w-9 h-9 rounded-lg bg-slate-50 border border-slate-100 flex items-center justify-center text-slate-400 hover:text-indigo-600 hover:bg-indigo-50 hover:border-indigo-100 hover:scale-110 transition-all duration-200"
                aria-label="LinkedIn"
              >
                <Linkedin size={16} />
              </a>
              <a
                href="mailto:hello@indibids.com"
                className="w-9 h-9 rounded-lg bg-slate-50 border border-slate-100 flex items-center justify-center text-slate-400 hover:text-indigo-600 hover:bg-indigo-50 hover:border-indigo-100 hover:scale-110 transition-all duration-200"
                aria-label="Email"
              >
                <Mail size={16} />
              </a>
            </div>
            <p className="mt-6 text-sm text-slate-400">hello@indibids.com</p>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="mt-16 pt-8 border-t border-slate-100 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-slate-400">
            &copy; 2025 IndiBids. All rights reserved.
          </p>
          <p className="text-xs text-slate-300">
            {">>"}  fast-forward your tenders
          </p>
        </div>
      </div>
    </footer>
  );
};
